import {
	DateInput,
	FormTab,
	ReferenceInput,
	SelectInput,
	TabbedForm,
	TextInput,
} from "react-admin";
import {RichTextInput} from "ra-input-rich-text";
import React from "react";

const PageForm = ({ type, ...props }) => (
	<TabbedForm {...props}>
		<FormTab label="Résumé pour liste">
			<TextInput fullWidth source="abstract_title" label="Titre" />
			<RichTextInput source="abstract_content" label="introduction pour liste" />
		</FormTab>

		<FormTab label="Page contenu">
			<TextInput fullWidth source="title" label="Titre" />
			<RichTextInput source="content" label="Contenu initial" />
		</FormTab>

		<FormTab label="Bouton">
			<TextInput source="button_text" label="Texte" />
			<TextInput source="button_url" label="Url de destination" />
			<TextInput source="button_icon" label="Icone" />
		</FormTab>

		<FormTab label="Configuration">
			<TextInput fullWidth source="meta_title" label="Titre SEO" />
			<TextInput fullWidth source="url" label="URL de la page" />
			<ReferenceInput source="category_id" reference="page_category">
				<SelectInput label="Catégorie" optionText="name" />
			</ReferenceInput>
			<DateInput source="created_date" label="Date de création" />
			<DateInput source="updated_date" label="Date de dernière modification" />
		</FormTab>
	</TabbedForm>
);

export default PageForm;
